// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-786422e5]{line-height:.9}.stats-container[data-v-786422e5]{border-radius:10px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
